import {
  Accordion,
  AccordionSummary,
  Box,
  styled,
  Typography,
} from '@mui/material';

export const Summary = styled(AccordionSummary)(
  ({ theme, $enableDnd }) => `
    padding:${$enableDnd ? '0px 32px 0px 32px' : '0 26px 16px 26px'};
    min-height: 35px;
    border-bottom: ${
      !$enableDnd && `1px solid ${theme.palette.brand.borderGrey}`
    }};

    & .MuiAccordionSummary-content {
        margin: 0;
        display: flex;
        align-items: center;
    }
  `,
);

export const SummaryLabel = styled(Typography)(
  ({ theme, $isError }) => `
    font-weight: 400;
    color:  ${$isError ? `${theme.status.danger.dark}` : `inherit`};
    display: flex;
    align-items: center;
  `,
);

export const AccordionContainer = styled(Box)`
  padding: 20px 0;
  overflow: auto;
`;

export const SortableItemContainer = styled('div')(
  ({ theme }) => `
    &.dragged {
      z-index: 1200; // to override Mui drawer of 1200
      background-color: ${theme.palette.common.white} ;
      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
    }
  `,
);

export const NumberCount = styled(Typography)(
  ({ theme }) => `
  display: flex;
  width: 20px;
  height: 20px;
  background: ${theme.palette.primary.main};
  justify-content: center;
  border-radius: 50%;
  color: white;
  font-size: 0.8rem;
  margin-right: 8px;
`,
);

export const StyledAccordian = styled(Accordion)`
  &.Mui-disabled {
    background-color: inherit; // Remove grey background for disabled state
    pointer-events: none; // Disable pointer events (clicks) when Accordion is disabled
  }
`;

export const StepContainer = styled('div')`
  width: 100%;
  display: flex;
  align-items: center;
`;

export const LabelsContainer = styled('div')`
  display: flex;
  justify-content: space-between;
  padding-top: 5px;
  padding-bottom: 4px;
`;

export const NumberContainer = styled(Box)(
  ({ theme, selected }) => `
      background-color: ${theme.palette.primary.main};
      display: flex;
      justify-content: center;
      align-items: center;
      height: 25px;
      width: 25px;
      font-size: 14px;
      color: ${theme.palette.primary.lightest};
      border-radius: 1000px;
      margin-right: 8px;
      ${
        selected &&
        `
          background-color: ${theme.palette.secondary.light};
      `
      }
  `,
);
